export const environment = {
  production: true,
  staging: true,
  hmr: false,
  SENTRY_ENABLED: false,
  SENTRY_DSN: '',
}

export const SERVER_URL = 'https://oa-staging-backend.aspik.is'
export const ORGANIZATION_TITLE = 'ASPIK-DEV'
export const ORGANIZATION_SUBTITLE = 'Staging'
